import {Box, Button, IconButton, Input, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {IconPlus, IconTrash, IconWriting} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";
import {IconText} from "../../../../assets/icons/IconText";


export const TabelarDataTable = ({data, onChange, onUpdate, setData}) => {

  return (
    <>
      <Box>
        <Button
          variant={"modal"} sx={{my: 2}} size={"small"}
          disabled={!data?.header && !data?.header?.length}
          onClick={() => {
            const items = [...(data?.items || [])];
            items.push(new Array(data?.header?.length).fill(""));
            onUpdate("items", items);
          }}
        >
          Add Row
        </Button>
      </Box>
      <Table border={1} sx={{borderColor: "divider", overflowX: "auto"}}>
        <TableHead>
          <TableRow>
            {data?.header?.map((item, index) => (
              <TableCell key={index} sx={{p: 0, px: 1}}>
                <Input
                  disableUnderline={true} fullWidth={true}
                  value={item} placeholder={"Enter name"}
                  sx={{color: grey[500], fontWeight: 600}}
                  inputProps={{sx: {pl: 1}}}
                  startAdornment={<IconText size={22} />}
                  endAdornment={(
                    <IconButton
                      size={"small"}
                      onClick={() => {
                        const header = data?.header?.filter((i, ind) => ind !== index);
                        const items = data?.items?.map(item => item?.filter((i, ind) => ind !== index));
                        setData(prev => ({...prev, header, items}))
                      }}
                    >
                      <IconTrash size={18}/>
                    </IconButton>
                  )}
                  onChange={e => {
                    const header = [...(data?.header || [])];
                    header[index] = e?.target?.value;
                    onUpdate("header", header);
                  }}
                />
              </TableCell>
            ))}
            <TableCell padding={"checkbox"} sx={{p: 0, px: 1}}>
              <IconButton
                size={"small"}
                onClick={() => {
                  const header = [...(data?.header || []), ""]
                  const items = [...(data?.items || [])];
                  if (items?.length) {
                    for (const item of items) {
                      item.push("");
                    }
                  } else {
                    items.push(new Array(header.length).fill(""))
                  }
                  setData(prev => ({...prev, header, items}))
                }}
              ><IconPlus size={18}/></IconButton>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            data?.items?.map((item, row) => {
              return (
                <TableRow key={row}>
                  {item?.map((cell, index) => (
                    <TableCell key={index} sx={{p: 0, px: 1}}>
                      <Input
                        disableUnderline={true} fullWidth={true}
                        value={cell} placeholder={"Enter value"}
                        sx={{color: grey[800], fontWeight: 600}}
                        inputProps={{sx: {pl: 1}}}
                        startAdornment={<IconWriting size={18}/>}
                        onChange={e => {
                          const items = [...(data?.items || [])];
                          items[row][index] = e?.target?.value;
                          onUpdate("items", items);
                        }}
                      />
                    </TableCell>
                  ))}
                  <TableCell padding={"checkbox"} sx={{p: 0, px: 1}}>
                    <IconButton
                      size={"small"}
                      onClick={() => {
                        const items = [...(data?.items || [])]?.filter((i, ind) => row !==ind);
                        onUpdate("items", items);
                      }}
                    >
                      <IconTrash size={18} />
                    </IconButton>
                  </TableCell>

                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </>
  )
}